import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { LandingComponent } from './landing/landing.component';

import { AuthGuard, RoleGuard, CanDeactivateGuard } from './_guards/index';

import { IntroductionComponent } from './introduction/introduction.component';
import { IntroHomeComponent } from './introduction/intro-home/intro-home.component';
import { OverviewComponent } from './introduction/overview/overview.component';
import { SummaryComponent } from './introduction/summary/summary.component';
import { FourElementComponent } from './introduction/four-element/four-element.component';
import { EcourseComponent } from './introduction/ecourse/ecourse.component';
import { SdgHomeComponent } from './sdg/sdg-home/sdg-home.component';
import { AdminComponent } from './admin/admin.component';
import { CapacityResourceComponent } from './sdg/capacity-resource/capacity-resource.component';
import { SdgComponent } from './sdg/sdg.component';
import { CapacityQuestComponent } from './sdg/capacity-quest/capacity-quest.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';
import { StatusComponent } from './sdg/status/status.component';
import { FinanceComponent } from './sdg/finance/finance.component';
import { GenderComponent } from './sdg/gender/gender.component';
import { PolicyComponent } from './sdg/policy/policy.component';
import { ResilienceComponent } from './sdg/resilience/resilience.component';
import { CapacityDataComponent } from './sdg/capacity-data/capacity-data.component';
import { CapacityReportComponent } from './sdg/capacity-report/capacity-report.component';
import { FinanceQuestComponent } from './sdg/finance-quest/finance-quest.component';
import { FinanceDataComponent } from './sdg/finance-data/finance-data.component';
import { FinanceReportComponent } from './sdg/finance-report/finance-report.component';
import { PolicyQuestComponent } from './sdg/policy-quest/policy-quest.component';
import { PolicyDataComponent } from './sdg/policy-data/policy-data.component';
import { PolicyReportComponent } from './sdg/policy-report/policy-report.component';
import { GenderQuestComponent } from './sdg/gender-quest/gender-quest.component';
import { GenderDataComponent } from './sdg/gender-data/gender-data.component';
import { GenderReportComponent } from './sdg/gender-report/gender-report.component';
import { ResilienceDataComponent } from './sdg/resilience-data/resilience-data.component';
import { ResilienceQuestComponent } from './sdg/resilience-quest/resilience-quest.component';
import { ResilienceReportComponent } from './sdg/resilience-report/resilience-report.component';
import { TransparencyComponent } from './sdg/transparency/transparency.component';
import { TransparencyQuestComponent } from './sdg/transparency-quest/transparency-quest.component';
import { TransparencyDataComponent } from './sdg/transparency-data/transparency-data.component';
import { TransparencyReportComponent } from './sdg/transparency-report/transparency-report.component';
//import { IntegrityComponent } from './sdg/integrity/integrity.component';
//import { IntegrityQuestComponent } from './sdg/integrity-quest/integrity-quest.component';
//import { IntegrityDataComponent } from './sdg/integrity-data/integrity-data.component';
//import { IntegrityReportComponent } from './sdg/integrity-report/integrity-report.component';
import { ResourceQuestComponent } from './sdg/resource-quest/resource-quest.component';
import { StatusReportComponent } from './sdg/status-report/status-report.component';
import { StatusDataComponent } from './sdg/status-data/status-data.component';
import { StatusQuestComponent } from './sdg/status-quest/status-quest.component';
import { ViewSummaryComponent } from './view-summary/view-summary.component';
import { AddQuestionComponent } from './sdg/add-question/add-question.component';
import { ProfileComponent } from './profile/profile.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { UserApprovalComponent } from './user-approval/user-approval.component';
import { ManageTeamComponent } from './manage-team/manage-team.component';
import { OnlineCourseComponent } from './online-course/online-course.component';

const appRoutes: Routes = [
    { path: 'admin', component: AdminComponent },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: '', component: LandingComponent },
    { path: 'forgot-pass', component: ForgotPasswordComponent },
    { path: 'password/reset/confirm/:uid/:token', component: ConfirmPasswordComponent },
    { path: 'user-approval/confirm/:uid', component: UserApprovalComponent, canActivate: [AuthGuard]},
    { path: 'introduction', component: IntroductionComponent, canActivate: [AuthGuard],
    children: [
        { path: 'intro-home', component: IntroHomeComponent , canActivate: [AuthGuard] },
        { path: 'overview', component: OverviewComponent, canActivate: [AuthGuard] },
        { path: 'summary', component: SummaryComponent, canActivate: [AuthGuard] },
        { path: 'four-element', component: FourElementComponent},
        { path: 'ecourse', component: EcourseComponent},
    ]},
    { path: 'sdg', component: SdgComponent, canActivate: [AuthGuard],
    children: [
        { path: 'sdg-home', component: SdgHomeComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'capacity-quest', component: CapacityQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        }  },
        { path: 'capacity-resource', component: CapacityResourceComponent , canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        }},
        { path: 'status', component: StatusComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'finance', component: FinanceComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'gender', component: GenderComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'policy', component: PolicyComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'resilience', component: ResilienceComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'capacity-data', component: CapacityDataComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'capacity-report', component: CapacityReportComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'finance-quest', component: FinanceQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        }  },
        { path: 'finance-data', component: FinanceDataComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'finance-report', component: FinanceReportComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'policy-quest', component: PolicyQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        }  },
        { path: 'policy-data', component: PolicyDataComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'policy-report', component: PolicyReportComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'gender-quest', component: GenderQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        }  },
        { path: 'gender-data', component: GenderDataComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'gender-report', component: GenderReportComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'resilience-quest', component: ResilienceQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        }  },
        { path: 'resilience-data', component: ResilienceDataComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'resilience-report', component: ResilienceReportComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'transparency', component: TransparencyComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        }  },
        { path: 'transparency-quest', component: TransparencyQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'transparency-data', component: TransparencyDataComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'transparency-report', component: TransparencyReportComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
//        { path: 'integrity', component: IntegrityComponent, canActivate: [RoleGuard],
//        data: {
//            authenticatedRole: [1,2,3]
//        }  },
//        { path: 'integrity-quest', component: IntegrityQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
//        data: {
//            authenticatedRole: [1,2,3]
//        } },
//        { path: 'integrity-data', component: IntegrityDataComponent, canActivate: [RoleGuard],
//        data: {
//            authenticatedRole: [1,2,3]
//        } },
//        { path: 'integrity-report', component: IntegrityReportComponent, canActivate: [RoleGuard],
//        data: {
//            authenticatedRole: [1,2,3]
//        } },
        { path: 'resource-quest', component: ResourceQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        }  },
        { path: 'status-quest', component: StatusQuestComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        }  },
        { path: 'status-data', component: StatusDataComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'status-report', component: StatusReportComponent, canActivate: [RoleGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },
        { path: 'add-question/:cid', component: AddQuestionComponent, canActivate: [RoleGuard], canDeactivate: [CanDeactivateGuard],
        data: {
            authenticatedRole: [1,2,3]
        } },

    ]
    },
    { path: 'view-summary', component: ViewSummaryComponent },
    { path: 'profile', component: ProfileComponent },
    { path: 'feedback', component: FeedbackComponent },
    { path: 'manage-team', component: ManageTeamComponent},
    { path: 'online-course', component: OnlineCourseComponent},
    // otherwise redirect to home

    { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts